import * as z from "zod";

// `local` also accepts ISO strings with no UTC offset (e.g. JSONB-sourced
// dates); `z.coerce.date()` parses those as UTC on our servers.
export const DateFromDateOrIsoStringSchema = z
  .union([z.iso.datetime({ offset: true, local: true }), z.date()])
  .pipe(z.coerce.date())
  .meta({ annotation: "Date" });
